// Date formatting utilities — uses advisor portal's more robust version
// with timezone-safe parsing and edge case handling
// Source: apps/advisor-portal/src/util/util.tsx (superset of client version)

export const dateFormatList = ["MM/DD/YYYY", "MM-DD-YYYY"];

export function formatDate(dateString: string): string {
  if (!dateString || dateString.trim() === "") {
    return "Not specified";
  }

  let date: Date;
  // Handle YYYY-MM-DD without timezone shift
  if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateString.split("-").map(Number);
    date = new Date(year, month - 1, day);
  } else {
    date = new Date(dateString);
  }

  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return new Intl.DateTimeFormat("en-US", options).format(date);
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export const getFormattedDate = (): string => {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};
